/* Adikopas — prekės puslapio logika
   1) rodyti tik pasirinktos spalvos nuotraukas
   2) dydžių lentelė iššokančiame lange
   3) pagaminimo termino ženklelis prie pirkimo mygtuko
   4) gyva vardo ir numerio peržiūra
   5) įkelia adikopas-size.js (dydis pagal ūgį) */
(function () {

  var EN = /^en/i.test(document.documentElement.lang || '');

  function toks(a) { return a.split(/[^a-z0-9]+/); }

  function colourFilter() {
    var g = document.querySelector('media-gallery');
    if (!g) return;
    var slides = [].slice.call(g.querySelectorAll('slideshow-slide'));
    if (!slides.length) return;

    var altToks = slides.map(function (s) {
      var i = s.querySelector('img');
      return toks(((i && i.alt) || '').toLowerCase());
    });

    function pick(values, current) {
      var hits = values.filter(function (v) {
        return v.length > 3 && altToks.some(function (w) { return w.indexOf(v) > -1; });
      });
      return hits.length > 1 ? { vals: hits, cur: current } : null;
    }

    var col = null;
    var sels = [].slice.call(document.querySelectorAll('select'));
    for (var i = 0; i < sels.length && !col; i++) {
      var vals = [].map.call(sels[i].options, function (o) { return (o.value || '').toLowerCase().trim(); });
      col = pick(vals, (sels[i].value || '').toLowerCase().trim());
    }
    if (!col) {
      var groups = {};
      [].slice.call(document.querySelectorAll('input[type=radio]')).forEach(function (r) {
        (groups[r.name] = groups[r.name] || []).push(r);
      });
      for (var k in groups) {
        if (col) break;
        var rvals = groups[k].map(function (r) { return (r.value || '').toLowerCase().trim(); });
        var checked = groups[k].filter(function (r) { return r.checked; })[0];
        col = pick(rvals, checked ? (checked.value || '').toLowerCase().trim() : '');
      }
    }
    if (!col || !col.cur || col.vals.indexOf(col.cur) < 0) return;

    var keep = [];
    slides.forEach(function (s, idx) {
      var owner = null;
      col.vals.forEach(function (v) { if (altToks[idx].indexOf(v) > -1) owner = v; });
      var hide = !!(owner && owner !== col.cur);
      if (s.hidden !== hide) s.hidden = hide;
      keep.push(!hide);
    });
    if (keep.indexOf(true) < 0) {
      slides.forEach(function (s) { if (s.hidden) s.hidden = false; });
      return;
    }

    function mask(list) {
      [].forEach.call(list, function (el, i) {
        if (i < keep.length) {
          var d = keep[i] ? '' : 'none';
          if (el.style.display !== d) el.style.display = d;
        }
      });
    }
    [].forEach.call(g.querySelectorAll('slideshow-controls'), function (c) {
      mask(c.querySelectorAll('.slideshow-control'));
    });
    mask(g.querySelectorAll('.dialog-thumbnails-list__thumbnail'));
    mask(g.querySelectorAll('.dialog-zoomed-gallery > li'));

    var act = -1;
    slides.forEach(function (s, i) { if (act < 0 && s.getAttribute('aria-hidden') === 'false') act = i; });
    if (act > -1 && !keep[act]) {
      var f = keep.indexOf(true);
      var b = g.querySelectorAll('slideshow-controls .slideshow-control')[f];
      if (b) b.click();
    }
  }

  var CSS = [
    '@import url(https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@600;800&display=swap);',
    '[id$="__custom_liquid_colour"]{display:none!important}',
    '.adk-size-btn{display:inline-flex;align-items:center;gap:6px;margin-inline-start:auto;padding:6px 12px;',
    'border:1px solid currentColor;border-radius:999px;background:none;color:inherit;font:inherit;',
    'font-size:.8rem;line-height:1;cursor:pointer;white-space:nowrap;text-decoration:none;opacity:1}',
    '.adk-size-btn:hover{background:rgb(var(--color-foreground-rgb)/.08)}',
    '.adk-size-btn svg{flex:none;opacity:.8}',
    '.adk-size-row{display:flex;align-items:center;gap:12px;width:100%;grid-column:1/-1}',
    '.adk-modal{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.55)}',
    '.adk-modal[open]{display:flex}',
    '.adk-modal__box{background:#fff;color:#111;max-width:760px;width:100%;max-height:86vh;overflow:auto;padding:28px 24px;position:relative;border-radius:4px}',
    '.adk-modal__box h2,.adk-modal__box h3{margin:24px 0 10px;font-size:1rem;padding-right:30px}',
    '.adk-modal__box h2:first-of-type,.adk-modal__box h3:first-of-type{margin-top:0}',
    '.adk-modal__box .rte-table-wrapper,.adk-tw{overflow-x:auto;margin:0 0 6px}',
    '.adk-modal__box table{width:100%;border-collapse:collapse;font-size:.85rem;min-width:420px}',
    '.adk-modal__box th,.adk-modal__box td{border-bottom:1px solid #e6e6e6;padding:7px 10px 7px 0;text-align:left;vertical-align:bottom}',
    '.adk-modal__box th{font-weight:600;font-size:.78rem;line-height:1.25;color:#555}',
    '.adk-modal__box td:first-child,.adk-modal__box th:first-child{white-space:nowrap;font-weight:600;color:#111}',
    '.adk-modal__box p{font-size:.82rem;color:#555;margin:8px 0 0;line-height:1.45}',
    '.adk-modal__close{position:absolute;top:10px;right:12px;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#111}',
    '.adk-lead{display:flex;align-items:center;gap:8px;font-size:.85rem;opacity:.75;margin:2px 0}',
    '.adk-plate{margin-top:10px;border-radius:6px;background:#17181a;padding:20px 18px 22px;text-align:center;overflow:hidden}',
    '.adk-plate__cap{font-size:.7rem;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.45);margin-bottom:12px}',
    '.adk-plate__name{font-family:"Saira Condensed",sans-serif;font-weight:800;color:#e2ac38;text-transform:uppercase;',
    'letter-spacing:.04em;line-height:1;font-size:clamp(22px,7vw,38px);word-break:break-word}',
    '.adk-plate__num{font-family:"Saira Condensed",sans-serif;font-weight:800;color:#fff;line-height:.9;',
    'font-size:clamp(56px,18vw,104px);margin-top:6px}',
    '.adk-plate__empty{opacity:.28}'
  ].join('');

  function css() {
    if (document.getElementById('adk-css')) return;
    var s = document.createElement('style');
    s.id = 'adk-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  function isHeading(el) { return /^H[2-4]$/.test(el.tagName); }

  /* Dydžio pasirinkimo antraštė: veikia ir su <select>, ir su radio mygtukais */
  function sizeHost() {
    var sel = [].slice.call(document.querySelectorAll('select')).filter(function (el) {
      return /dydis|size/i.test(el.name || '');
    })[0];
    if (sel) {
      var p = sel.parentElement;
      for (var i = 0; i < 4 && p; i++) {
        var lab = p.querySelector('label, legend');
        if (lab) return lab;
        p = p.parentElement;
      }
      return null;
    }
    var r = [].slice.call(document.querySelectorAll('input[type=radio]')).filter(function (i) {
      return /dydis|size/i.test((i.name || '').split('-')[0]);
    })[0];
    if (!r) return null;
    var fs = r.closest('fieldset');
    return fs ? fs.querySelector('legend') : null;
  }

  /* Modelio perjungimas perpiesia dydziu bloka, todel mygtukas atkuriamas kaskart */
  function sizeChart() {
    var modal = document.querySelector('.adk-modal');
    if (modal) { addSizeBtn(modal); return; }
    var hs = [].slice.call(document.querySelectorAll('h2,h3,h4')).filter(function (h) {
      var t = (h.textContent || '').trim().toLowerCase();
      if (t.indexOf('dyd') === 0) return true;
      if (!EN) return false;
      if (t.indexOf('size') > -1) return true;
      var n = h.nextElementSibling;
      return !!(n && (n.tagName === 'TABLE' || (n.querySelector && n.querySelector('table'))));
    });
    if (!hs.length) return;

    var box = document.createElement('div');
    box.className = 'adk-modal__box';
    box.innerHTML = '<button type="button" class="adk-modal__close" aria-label="' + (EN ? 'Close' : 'Uždaryti') + '">&times;</button>';
    hs.forEach(function (h) {
      var n = h.nextElementSibling, chunk = [h];
      while (n && !isHeading(n)) { chunk.push(n); n = n.nextElementSibling; }
      chunk.forEach(function (el) { box.appendChild(el); });
    });

    modal = document.createElement('div');
    modal.className = 'adk-modal';
    modal.appendChild(box);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('adk-modal__close')) modal.removeAttribute('open');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') modal.removeAttribute('open'); });
    document.body.appendChild(modal);

    addSizeBtn(modal);
  }

  function addSizeBtn(modal) {
    if (document.querySelector('.adk-size-btn')) return;

    var host = sizeHost();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'adk-size-btn';
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M7 7v3M12 7v4M17 7v3"/></svg>' +
      '<span>' + (EN ? 'Size guide' : 'Dydžių lentelė') + '</span>';
    btn.addEventListener('click', function () { modal.setAttribute('open', ''); });

    if (host) {
      host.classList.add('adk-size-row');
      host.appendChild(btn);
    } else {
      var bb = document.querySelector('buy-buttons-component, [class*=buy-buttons]');
      if (!bb) return;
      var w2 = document.createElement('div');
      w2.style.margin = '2px 0';
      w2.appendChild(btn);
      bb.parentNode.insertBefore(w2, bb);
    }
  }

  /* pagaminimo terminas is paties gaminio aprasymo */
  function leadText() {
    var p = [].slice.call(document.querySelectorAll('p')).filter(function (el) {
      return /^(pagaminimas|production)\s*:/i.test((el.textContent || '').trim());
    })[0];
    if (!p) return '';
    var parts = (p.textContent || '').split(':');
    if (parts.length < 2) return '';
    var txt = parts.slice(1).join(':').split('.')[0];
    var dash = txt.indexOf('—');
    if (dash > 0) txt = txt.slice(0, dash);
    return txt.trim();
  }

  function leadTime() {
    if (document.querySelector('.adk-lead')) return;
    var txt = leadText();
    if (!txt) return;
    var bb = document.querySelector('buy-buttons-component, [class*=buy-buttons]');
    if (!bb) return;
    var d = document.createElement('div');
    d.className = 'adk-lead';
    d.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span></span>';
    d.querySelector('span').textContent = (EN ? 'Production: ' : 'Pagaminimas: ') + txt;
    bb.parentNode.insertBefore(d, bb);
  }

  function plate() {
    var inputs = [].slice.call(document.querySelectorAll('product-custom-property-component input, product-custom-property-component textarea'));
    var nameEl = null, numEl = null;
    inputs.forEach(function (i) {
      var n = '';
      try { n = decodeURIComponent(i.getAttribute('name') || '').toLowerCase(); }
      catch (e) { n = (i.getAttribute('name') || '').toLowerCase(); }
      if (!nameEl && (n.indexOf('vardas') > -1 || n.indexOf('name') > -1)) nameEl = i;
      if (!numEl && (n.indexOf('numeris') > -1 || n.indexOf('number') > -1)) numEl = i;
    });
    if (!nameEl && !numEl) return;
    var last = numEl || nameEl;
    var anchor = last.closest ? last.closest('product-custom-property-component') : null;
    if (!anchor) return;

    var pl = document.querySelector('.adk-plate');
    if (!pl) {
      pl = document.createElement('div');
      pl.className = 'adk-plate';
      pl.innerHTML = '<div class="adk-plate__cap">Taip atrodys jūsų užrašas</div><div class="adk-plate__name"></div><div class="adk-plate__num"></div>';
      anchor.parentNode.insertBefore(pl, anchor.nextSibling);
    }
    var nEl = pl.querySelector('.adk-plate__name');
    var xEl = pl.querySelector('.adk-plate__num');

    function draw() {
      var nm = ((nameEl && nameEl.value) || '').trim();
      var nu = ((numEl && numEl.value) || '').trim();
      nEl.textContent = nm || 'PAVARDĖ';
      nEl.className = 'adk-plate__name' + (nm ? '' : ' adk-plate__empty');
      nEl.style.display = nameEl ? '' : 'none';
      xEl.textContent = nu || '00';
      xEl.className = 'adk-plate__num' + (nu ? '' : ' adk-plate__empty');
      xEl.style.display = numEl ? '' : 'none';
    }
    if (!pl.getAttribute('data-bound')) {
      pl.setAttribute('data-bound', '1');
      [nameEl, numEl].forEach(function (i) { if (i) i.addEventListener('input', draw); });
    }
    draw();
  }

  /* Pristatymo blokas: terminas imamas is to paties gaminio, ne bendras tekstas */
  function shipInfo() {
    var box = document.querySelector('[class*="text_pristatymas"]');
    if (!box) return;
    var ps = box.querySelectorAll('p');
    if (ps.length < 2) return;
    var term = leadText();
    var txt = term
      ? (EN ? 'Production – ' + term + '. Courier delivery in 1–2 business days.'
            : 'Pagaminimas – ' + term + '. Kurjeris pristato per 1–2 darbo dienas.')
      : (EN ? 'Courier delivery in 1–2 business days.'
            : 'Kurjeris pristato per 1–2 darbo dienas.');
    if (ps[1].textContent.trim() === txt) return;
    ps[1].textContent = txt;
    for (var i = 2; i < ps.length; i++) ps[i].remove();
  }

  function loadSize() {
    if (document.querySelector('script[data-adk-size]')) return;
    var me = [].slice.call(document.querySelectorAll('script[src]')).filter(function (s) {
      return s.src.indexOf('colour-filter.js') > -1;
    })[0];
    if (!me) return;
    var s = document.createElement('script');
    s.src = me.src.split('?')[0].replace('colour-filter.js', 'adikopas-size.js');
    s.setAttribute('data-adk-size', '1');
    document.body.appendChild(s);
  }

  function run() { colourFilter(); css(); sizeChart(); leadTime(); shipInfo(); plate(); loadSize(); }
  var t = 0;
  function schedule() { clearTimeout(t); t = setTimeout(run, 140); }
  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('change', schedule, true);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();